import { configureStore } from "@reduxjs/toolkit";
import productsReducer from "./productsSlice.js";
import authReducer from "./authSlice.js";
import ordersReducer from "./ordersSlice.js";
import cartReducer from "./cartSlice.js";
import addressReducer from "./addressSlice.js";
import specialOffersReducer from "./specialOffersSlice.js";

const store = configureStore({
  reducer: {
    products: productsReducer,
    auth: authReducer,
    orders: ordersReducer,
    cart: cartReducer,
    addresses: addressReducer,
    specialOffers: specialOffersReducer,
  },
});

export default store;
